import React from 'react';
import { useTheme } from '@/context/ThemeContext';
import { Wrench, Clock } from '@phosphor-icons/react';

const LOGO_DARK = "https://customer-assets.emergentagent.com/job_da191abd-9276-45a7-bd48-1757c1f4e471/artifacts/p5urxzpf_diametor_logo_black__1_-removebg-preview.png";
const LOGO_LIGHT = "https://customer-assets.emergentagent.com/job_debt-cycle/artifacts/gzyrfqiy_diametor_logo_white-removebg-preview.png";

export default function MaintenancePage({ until, message }) {
  const { theme } = useTheme();
  const isDark = theme === 'dark';
  const untilText = until ? new Date(until).toLocaleString(undefined, {
    weekday: 'short', day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit',
  }) : null;

  return (
    <div className={`min-h-screen flex items-center justify-center px-6 ${isDark ? 'bg-zinc-950' : 'bg-white'}`} data-testid="maintenance-page">
      <div className="max-w-md w-full text-center">
        <img src={isDark ? LOGO_DARK : LOGO_LIGHT} alt="Diametor" className="h-9 mx-auto mb-8" />
        <div className={`mx-auto mb-6 w-16 h-16 rounded-full flex items-center justify-center ${isDark ? 'bg-yellow-400/10' : 'bg-yellow-100'}`}>
          <Wrench size={30} weight="bold" className="text-yellow-400" />
        </div>
        <h1 className={`font-outfit text-2xl font-bold mb-3 ${isDark ? 'text-zinc-50' : 'text-zinc-950'}`}>Platform Under Maintenance</h1>
        <p className={`font-ibm text-sm leading-relaxed ${isDark ? 'text-zinc-400' : 'text-zinc-600'}`}>
          {message || 'We are performing scheduled maintenance to improve your experience. The platform is temporarily frozen.'}
        </p>
        {untilText && (
          <div className={`mt-6 inline-flex items-center gap-2 px-4 py-2.5 rounded-sm border ${isDark ? 'border-yellow-400/30 bg-yellow-400/5' : 'border-yellow-300 bg-yellow-50'}`} data-testid="maintenance-until">
            <Clock size={16} weight="bold" className="text-yellow-400" />
            <span className={`font-ibm text-sm font-semibold ${isDark ? 'text-zinc-200' : 'text-zinc-800'}`}>Please wait until {untilText}</span>
          </div>
        )}
        <p className={`font-ibm text-[11px] mt-8 ${isDark ? 'text-zinc-600' : 'text-zinc-400'}`}>
          Need help? Contact support@diametor.com or +91-9072336912
        </p>
      </div>
    </div>
  );
}
